import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=703affa8&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=ts"
export * from "./BasicLayout.vue?vue&type=script&lang=ts"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=703affa8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703affa8",
  null
  
)

export default component.exports